import React, { Component } from "react";
import { Grid } from "semantic-ui-react";

/**
 * Imports the Agenda layout stylesheet.
 */
import "./Agenda.css";

import AgendaTimetable from "./timetable/AgendaTimetable";
import AgendaPlaner from "./planer/AgendaPlaner";

/**
 * Agenda : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Agenda application module containing the timetable and
 * planer components.
 */
class Agenda extends Component {
  state = {};
  render() {
    return (
      <div className="agenda-view">
        <Grid>
          <Grid.Row>
            <Grid.Column width={10}>
              <AgendaTimetable />
            </Grid.Column>
            <Grid.Column width={6}>
              <AgendaPlaner />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default Agenda;



// WEBPACK FOOTER //
// ./src/modules/agenda/Agenda.js